import { useEffect, useState } from "react";
import { PaperPlaneTilt, FloppyDisk } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export default function DailySummarySettings() {
  const [cfg, setCfg] = useState({ enabled: false, time: "23:30" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings/daily-summary").then((r) => setCfg({ enabled: !!r.data.enabled, time: r.data.time || "23:30" })).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/settings/daily-summary", cfg);
      toast.success("Resumen diario guardado");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  const sendNow = async () => {
    setBusy(true);
    try {
      await api.post("/admin/daily-summary/send-now");
      toast.success("Resumen enviado por Telegram");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="card-flat p-6 rounded-2xl" data-testid="daily-summary-settings">
      <div className="label-cap mb-1">resumen diario por telegram</div>
      <p className="text-sm text-[var(--text-secondary)] mb-4">
        Envía cada día a los destinatarios con aviso de tareas un resumen de las últimas 24 h: horas por tarea, quién hizo qué, tareas en curso y pendientes. Se comprueba cada 15 minutos.
      </p>
      <div className="flex items-center gap-3 flex-wrap">
        <label className="inline-flex items-center gap-2 cursor-pointer font-display font-semibold text-sm">
          <input
            type="checkbox"
            checked={cfg.enabled}
            onChange={(e) => setCfg((c) => ({ ...c, enabled: e.target.checked }))}
            data-testid="daily-summary-enabled"
            className="w-4 h-4 accent-[var(--primary)]"
          />
          Activado
        </label>
        <input
          type="time"
          value={cfg.time}
          onChange={(e) => setCfg((c) => ({ ...c, time: e.target.value }))}
          data-testid="daily-summary-time"
          className="px-3 py-2 rounded-xl border border-[var(--border)] bg-white font-mono"
        />
        <button type="button" onClick={save} disabled={busy} data-testid="daily-summary-save" className="btn-primary px-4 py-2 rounded-xl font-display font-bold inline-flex items-center gap-2 disabled:opacity-50">
          <FloppyDisk size={16} /> Guardar
        </button>
        <button type="button" onClick={sendNow} disabled={busy} data-testid="daily-summary-send-now" className="px-4 py-2 rounded-xl border border-[var(--border)] bg-white font-display font-semibold inline-flex items-center gap-2 hover:bg-[var(--bg)] disabled:opacity-50">
          <PaperPlaneTilt size={16} /> Enviar ahora
        </button>
      </div>
    </div>
  );
}
